export default "__VITE_ASSET__Ndf2mBS9__"